import request from '@/utils/request'

// 查询任务提交列表
export function listTaskSubmit(query) {
  return request({
    url: '/task/task/submit/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务提交分页
export function pageTaskSubmit(query) {
  return request({
    url: '/task/task/submit/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务提交详细
export function getTaskSubmit(data) {
  return request({
    url: '/task/task/submit/detail',
    method: 'get',
    params: data
  })
}

// 新增任务提交
export function addTaskSubmit(data) {
  return request({
    url: '/task/task/submit/add',
    method: 'post',
    data: data
  })
}

// 修改任务提交
export function updateTaskSubmit(data) {
  return request({
    url: '/task/task/submit/edit',
    method: 'post',
    data: data
  })
}

// 删除任务提交
export function delTaskSubmit(data) {
  return request({
    url: '/task/task/submit/delete',
    method: 'post',
    data: data
  })
}

// 批量通过联盟申请
export function batchPassTaskSubmit(data) {
  return request({
    url: '/task/task/submit/batchPass',
    method: 'post',
    data: data
  })
}

// 批量拒绝联盟申请
export function batchRejectTaskSubmit(data) {
  return request({
    url: '/task/task/submit/batchReject',
    method: 'post',
    data: data
  })
}